function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Brick } from "zengular";
import "./magic-form.scss";
import magic from "../modules/magic";
import { Guard, LengthValidator } from "zengular-util";

var MagicFormBrick = /*#__PURE__*/function (_Brick) {
  _inherits(MagicFormBrick, _Brick);

  var _super = _createSuper(MagicFormBrick);

  function MagicFormBrick() {
    _classCallCheck(this, MagicFormBrick);

    return _super.apply(this, arguments);
  }

  _createClass(MagicFormBrick, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.item = {};
      this.root.classList.add('magic-form');
      this.handler = magic.getHandler(this.dataset.handler);
      this.validators = {};
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        item: this.item,
        dataset: this.dataset,
        handler: this.handler
      };
    }
  }, {
    key: "setup",
    value: function setup(item, attributes) {
      var _this = this;

      this.item = item;
      this.render().then(function () {
        var formBuilder = _this.formBuilder;
        if (_typeof(formBuilder) === "object") return _this.buildForm(formBuilder);
      }).then(function () {
        _this.$$('input').each(function (input) {
          var wrapper = document.createElement('div');
          var label = document.createElement('label');
          label.innerHTML = _this.handler.translate(['input', input.dataset.name]);
          wrapper.classList.add('input');
          wrapper.dataset.name = input.dataset.name;
          wrapper.appendChild(label);
          input.parentElement.insertBefore(wrapper, input);
          wrapper.appendChild(input);
          input.controller.setup(item, _this.handler.name, attributes);
          if (typeof input.dataset.inline !== "undefined") wrapper.classList.add('inline');
        });
      }).then(function () {
        _this.$$('input').each(function (input) {
          var hint = _this.$('.hint[data-for="' + input.dataset.name + '"]').node;

          if (hint !== null) {
            var label = input.previousSibling;
            label.classList.add('hinted');
            label.addEventListener('click', function (event) {
              return hint.classList.toggle('visible');
            });
            input.after(hint);
          }
        });
      });
    }
  }, {
    key: "error",
    value: function error(field, message) {
      var input = this.$('div.input[data-name="' + field + '"]').node;
      if (input) input.dataset.error = '▼ ' + message;
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.$('div.input').each(function (input) {
        return input.removeAttribute("data-error");
      });
    }
  }, {
    key: "data",
    get: function get() {
      var _this2 = this;

      var data = {};
      this.$$('input').each(function (item) {
        return data[item.controller.name] = item.controller.value;
      });
      var validators = Object.keys(this.validators);

      if (validators.length) {
        var guard = new Guard();
        validators.forEach(function (name) {
          var g = guard.create(name);

          _this2.validators[name].forEach(function (validator) {
            return g.add(validator);
          });
        });
        return guard.test(data);
      }

      return data;
    }
    /**
     * @param {FormBuilder} formBuilder
     */

  }, {
    key: "buildForm",
    value: function buildForm(formBuilder) {
      var _this3 = this;

      var promises = [];
      this.validators = Object.assign(this.validators, formBuilder.validators);
      formBuilder.sections.forEach(function (section) {
        var sectionElement;

        if (section.finder === null) {
          sectionElement = document.createElement('section');

          _this3.root.appendChild(sectionElement);
        } else {
          sectionElement = section.finder.node;
        }

        if (section.label) {
          var label = document.createElement('label');
          label.innerHTML = section.label;
          sectionElement.appendChild(label);
        }

        section.inputs.forEach(function (input) {
          var attributes = input.attributes;
          attributes.name = input.name;
          if (input.inline) attributes.inline = true;

          if (input.hint) {
            var hint = document.createElement('div');
            hint.classList.add('hint');
            hint.dataset.for = input.name;
            hint.innerHTML = input.hint;

            _this3.root.appendChild(hint);
          }

          promises.push(input.input.create('div', true, attributes).then(function (inputBrick) {
            inputBrick.setAttributes(attributes);
            return Object.create({
              inputBrick: inputBrick,
              input: input,
              sectionElement: sectionElement
            });
          }));
        });
      });
      return Promise.all(promises).then(function (inputs) {
        inputs.forEach(function (_ref) {
          var inputBrick = _ref.inputBrick,
              input = _ref.input,
              sectionElement = _ref.sectionElement;
          sectionElement.appendChild(inputBrick.root);
        });
      });
    }
  }]);

  return MagicFormBrick;
}(Brick);

export { MagicFormBrick as default };